import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Star } from 'lucide-react';
import { Button } from './Button';
export function Hero() {
  const badges = ['Descarga inmediata', 'Compatible con celular', 'Pago único', 'Garantía 7 días'];
  return <section className="relative pt-10 pb-16 md:pt-16 md:pb-24 px-6 overflow-hidden bg-white" data-id="element-67">
      <div className="max-w-4xl mx-auto text-center" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-69">
          {/* Etiqueta superior */}
          <span className="inline-block py-1.5 px-4 rounded-full bg-green-100 text-primary font-bold text-xs tracking-widest uppercase mb-6 shadow-sm" data-id="element-70">
            Enciclopedia Gluko Libre Argentina
          </span>

          {/* Título */}
          <h1 className="font-serif font-black text-gray-900 leading-[1.05] tracking-tight text-5xl sm:text-6xl md:text-7xl mb-4" data-id="element-71">
            VOLVÉ A DISFRUTAR LAS{' '}
            <span className="text-primary" data-id="element-72">COMIDAS QUE MÁS TE GUSTAN</span>
          </h1>

          {/* Subtítulo principal destacado */}
          <p className="font-serif text-2xl sm:text-3xl md:text-4xl text-gray-800 leading-tight mb-6" data-id="element-73">
            Aunque tengas{' '}
            <span className="text-primary font-bold" data-id="element-74">
              diabetes, prediabetes o resistencia a la insulina
            </span>
            .
          </p>

          {/* Texto descriptivo */}
          <p className="text-lg sm:text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto mb-10" data-id="element-75">
            Más de <span className="text-primary font-bold" data-id="element-76">100 recetas</span>{' '}
            inspiradas en panes, empanadas, pizzas, pastas, postres y muchas
            otras comidas argentinas, utilizando ingredientes{' '}
            <span className="text-accent font-bold" data-id="element-77">fáciles de conseguir</span>.
          </p>
        </motion.div>

        {/* Imagen principal del producto — mucho más grande */}
        <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative mx-auto w-full max-w-lg sm:max-w-xl md:max-w-2xl mb-8" data-id="element-78">
          <div className="absolute -inset-10 bg-green-100/50 rounded-[3rem] blur-3xl -z-10" data-id="element-79" />
          <img src="https://cdn.magicpatterns.com/uploads/b4BQKUnCQpZ48J6KjWDaFM/ChatGPT_Image_19_jun_2026,_03_05_32.png" alt="Portada de la Enciclopedia Gluko Libre Argentina" className="w-full rounded-3xl shadow-[0_20px_50px_rgba(0,0,0,0.15)] ring-1 ring-black/5" data-id="element-80" />
        </motion.div>

        {/* Rating */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} className="flex flex-col items-center justify-center gap-2 mb-8" data-id="element-81">
          <div className="flex gap-1 text-accent" data-id="element-82">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" data-id="element-83" />)}
          </div>
          <p className="text-base font-bold text-gray-700" data-id="element-84">
            Más de 2.300 personas ya la descargaron.
          </p>
        </motion.div>

        {/* Badges */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6
      }} className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 mb-10" data-id="element-85">
          {badges.map((badge, index) => <span key={index} className="inline-flex items-center gap-2 text-sm md:text-base text-gray-800 font-bold bg-gray-50 px-4 py-2 rounded-xl border border-gray-100 shadow-sm" data-id="element-86">
              <CheckCircle2 className="w-5 h-5 text-primary flex-shrink-0" data-id="element-87" />
              {badge}
            </span>)}
        </motion.div>

        {/* Botón CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.7
      }} className="flex flex-col items-center" data-id="element-88">
          <Button className="w-full sm:w-auto" data-id="element-89">
            QUIERO VOLVER A DISFRUTAR LA COMIDA
          </Button>
        </motion.div>
      </div>
    </section>;
}